<template>
  <div class="ed-field-checklist">
    <span class="ed-label">{{ title }}</span>
    <div class="ed-check-grid">
      <v-checkbox
        v-for="field in fields"
        :key="field.key"
        :input-value="value && value[field.key]"
        :label="field.label"
        color="primary"
        hide-details
        @change="toggle(field.key, $event)"
      ></v-checkbox>
    </div>
  </div>
</template>

<script>
// Campos de CampaignInputInformation exibidos nas modais do checkout (mesma ordem/rótulos da tela antiga).
export const INPUT_FIELDS = Object.freeze([
  Object.freeze({ key: "company", label: "Empresa" }),
  Object.freeze({ key: "department", label: "Departamento" }),
  Object.freeze({ key: "address", label: "Endereço" }),
  Object.freeze({ key: "state", label: "Estado" }),
  Object.freeze({ key: "phone", label: "Telefone" }),
  Object.freeze({ key: "gender", label: "Gênero" }),
  Object.freeze({ key: "birthDate", label: "Data de nascimento" }),
  Object.freeze({ key: "memberCode", label: "Código de indicação" }),
  Object.freeze({ key: "alternativePhone", label: "Telefone alternativo" }),
  Object.freeze({ key: "cityWithState", label: "Cidade (com busca)" }),
]);

export function emptyFields() {
  return INPUT_FIELDS.reduce((fields, field) => {
    fields[field.key] = false;
    return fields;
  }, {});
}

export default {
  name: "EditorFieldChecklist",
  props: {
    value: { type: Object, default: null },
    title: { type: String, required: true },
  },
  data() {
    return { fields: INPUT_FIELDS };
  },
  methods: {
    toggle(key, checked) {
      this.$emit("input", Object.assign({}, this.value, { [key]: !!checked }));
    },
  },
};
</script>

<style scoped>
.ed-field-checklist {
  margin: 4px 0 12px;
  padding: 14px 16px;
  border-radius: 8px;
  background: var(--ced-bg, #f6f7f9);
}
</style>
